export class BadgeControl {
  badgeTitle: string;
  badgeLabel: string;
  isDataLoaded?: boolean;
  constructor() {}
}
